const Manicure = () => {
  return (
    <div>
      <h1>Manikűr szolgáltatásaink</h1>
      <p>
        Kezünk és körmünk ápolása kiemelten fontos minden évszakban. Az elegáns
        megjelenésért egyszerű manikűrrel vagy erősítő japán manikűrrel is
        gondoskodhatunk. Ha szeretnéd tökéletesíteni a külsőd, választhatod a
        sima lakkozást vagy a tartós gél lakkozást is. Emellett különleges
        élményt nyújt a bőrünknek a paraffinos kézápolás, melynek hatására
        selymesen puhává válik.
      </p>
      <br></br>
      <div className="pedicure">
        <h3>
          {" "}
          <br></br>
          <u>GÉPI MANIKŰR</u>
        </h3>
        <li>Ár: 7000 Ft</li>
        <li>Várható időtartam: 30 perc</li>
        <li>Szolgáltatás tartalma:</li>
        <p>
          Szolgáltatás tartalma: A gépi manikűr során speciális frézereket
          használunk, hogy kialakítsuk a kívánt körömhosszt és formát. Teljes
          mértékben egyenletes körömfelületet eredményezünk, és gondoskodunk a
          körömlemez körüli és a körömlemezre tapadt bőr kezeléséről is. A köröm
          felületét mattra vagy fényesre polírozzuk, igényednek megfelelően. A
          szolgáltatás befejezéseként pedig hatékony bőrápolást kap a kezed,
          hogy tökéletesen ápolt és szép megjelenést érhessünk el.
        </p>
        <p>
          Reméljük, hogy a manikűr szolgáltatásaink segítségével a kezed és a
          körmöd mindig tökéletes állapotban lesznek, és garantáltan elégedett
          leszel a látvánnyal!
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>JAPÁN MANIKŰR</u>
        </h3>
        <p>Ár: 10000 Ft</p>
        <p>Szolgáltatás várható ideje: 1 óra</p>
        <p>Szolgáltatás tartalma: Japán manikűr</p>
        <p>
          Japán manikűr szolgáltatás során a körmök formázását követően a
          körömlemez méhviaszos ápolását végezzük. A speciális paszta beépülve
          táplálja, ápolja, rugalmassá teszi a természetes körömlemezt és
          visszaadja annak természetes fényét.
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>KLASSZIKUS MANIKŰR</u>
        </h3>
        <p>Klasszikus manikűr - 3000 Ft</p>
        <p>Extrém rossz állapotban lévő körmök esetén + 2000 Ft</p>
        <p>A szolgáltatás várható időtartama: 30 perc</p>
        <p>A szolgáltatás részletei: Gépi manikűr</p>
        <p>
          A gépi manikűr során speciális frézerkéket használunk. Kialakítjuk a
          kívánt körömhosszt és formát, az egyenletes körömfelületet, valamint
          kezeljük a körömlemezt körülvevő és ráragadt bőrt. A köröm felületét
          kérheted mattnak vagy fényesen polírozva. A szolgáltatás zárása a bőr
          hatékony ápolása.
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>SAJÁT KÖRÖM MEGERŐSÍTÉSE</u>
        </h3>
        <p>Ár: 10000 Ft</p>
      </div>
      <br></br>
      <h1>Géllakk szolgáltatások</h1>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>GÉLLAKK - EGYSZÍNŰ</u>
        </h3>
        <p>Erősített gél lakk (teli szín, baby boomer) - 8500 Ft</p>
        <p>Erősített gél lakk (francia, ombre) - 9000 Ft</p>
        <p>Erősített gél lakk 'S' méret - 10000 Ft</p>
        <p>Teljes gél lakk csere + 1000 Ft</p>
        <p>
          Rossz állapotban lévő / gél lakk cseréje (teljes alap cserével) + 2000
          Ft
        </p>
        <p>Szolgáltatás várható időtartama: 1 óra</p>
        <p>
          Szolgáltatás tartalma: Gépi manikűr, Előző géllakk eltávolítása,
          Egyszínű erősített gél lakkozás. Gépi manikűr és az előző géllakk
          eltávolítását követően egy erősített géllakkozást készítem neked. A
          körmöd lehet egyszínű vagy minden körmöd más színű. A szolgáltatásban
          válaszd géllakk prémiumszolgáltatatásunkat.
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>GÉLLAKK - PRÉMIUM</u>
        </h3>
        <p>Ár: 14000 Ft</p>
        <p>Szolgáltatás várható időtartama: 1,5 óra</p>
        <p>
          A szolgáltatás magában foglalja: Gépes manikűr, a korábbi géllakk
          eltávolítása, erősített géllakk alkalmazása (egyszínű, Ombre, Francia,
          Babyboomer), 2 díszítés
        </p>
        <p>
          A gépes manikűr és a korábbi géllakk eltávolítása után, erősített
          géllakkozással teszem újjá a körmeidet. Prémium szolgáltatásunk
          keretében választhatsz az egyszínű, francia, ombre, vagy akár
          babyboomer díszítések közül. A szolgáltatás tartalmaz két díszítést
          is, amelyek akár egy picit extravagánsabbak is lehetnek, a
          szolgáltatás időkeretein belül.
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>GÉLLAKK ELTÁVOLÍTÁS</u>
        </h3>
        <p>Gél lakk eltávolítás + manikür - 4000 Ft</p>
        <p>Gél lakk végleges eltávolítás - 3500 Ft</p>
        <p>Szolgáltatás várható időtartama: 45 perc</p>
        <p>Szolgáltatás tartalma: Gépi manikűr, Géllakk eltávolítás.</p>
        <p>
          A géllakk eltávolítása csiszológép és oldószerek segítségével
          történik. Ez a folyamat a körmökben lévő természetes olajokat is
          eltávolítja, így fontos a megfelelő manikűr és a körmök polírozása,
          hogy visszaállítsuk a természetes fényüket.
        </p>
        <p>
          Rágott köröm esetén is tudunk segíteni, ebben az esetben egy speciális
          technikát alkalmazunk, hogy a köröm visszanyerje esztétikus
          megjelenését.
        </p>
      </div>
      <br></br>
      <br></br>
    </div>
  );
};

export default Manicure;
